/** Собственные кассиры — служба Cashiers (RP-CU1…CU3): карточка, код и связи с кассирами источников. */
const ROOT = '/api/cashiers/v1/people'
const item = (id: string) => `${ROOT}/${encodeURIComponent(id)}`
export const OWN_CASHIER_URLS = {
  list: ROOT,
  item,
  code: (id: string) => `${item(id)}/code`,
  links: (id: string) => `${item(id)}/links`,
} as const
